import { Component } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {FormsModule, NgForm, ReactiveFormsModule} from "@angular/forms";
import Swal from "sweetalert2";
import {of, switchMap} from "rxjs";
import moment from "moment";

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})
export class ChangePasswordComponent {

  constructor(
    public authService: AuthService,
    public router: Router
  ) {}

  onChangePassword(form: NgForm) {
    if(form.invalid || (form.value.password !== form.value.confirmPassword)){
      let message: string;

      if((form.value.password !== form.value.confirmPassword)){
        message = 'Le password non corrispondono';
      }else{
        message = 'Compila tutti i campi';
      }

      Swal.fire({
        icon: 'error',
        title: 'Ops...',
        text: message,
        confirmButtonColor: '#050A30'
      });

      return;
    }

    this.authService.changePassword(form.value.oldPassword, form.value.password)
      .pipe(
        switchMap((response) => {
          form.resetForm();

          const currentDate = moment().format('YYYY-MM-DD');
          this.router.navigate(['/calendario/' + currentDate]);

          Swal.fire({
            icon: 'success',
            title: 'Password aggiornata',
            timer: 1500
          });

          return of(response);
        })
      )
      .subscribe({
        error: (error) => {
          console.error("Errore nel cambio della password", error);

          Swal.fire({
            icon: 'error',
            title: 'Ops...',
            text: error.error.message,
            confirmButtonColor: '#050A30'
          });
        }
      });
  }

}
